import { usePermisos } from "../../context/PermisosContext";
import TableroRecursos from "../Tableros/TableroRecursos";
// src/components/Estanques/Estanques.jsx
import React, { useEffect, useMemo, useState } from "react";
import CrearEstanque from "./CrearEstanque";
import AdministrarEstanques from "./AdministrarEstanques";

// Lee el bitset desde localStorage y verifica un bit 1-based.
// Devuelve true/false si existe el bit; undefined si la clave no está definida (=> opcional).


const Estanques = ({ initialTab = "tablero", onTabChange }) => {
  const { can: hasFromBitset } = usePermisos();
  // Gate global de la ventana; si el bit no existe, no bloqueamos.
  const canViewWindow = hasFromBitset("ESTANQUES_VIEW") ?? true;

  // Permisos de pestañas:
  const canCrearView = hasFromBitset("ESTANQUES_TAB_CREAR_VIEW") !== false;
  const canCrearEdit = hasFromBitset("ESTANQUES_TAB_CREAR_EDIT") !== false;
  const canAdminView = hasFromBitset("ESTANQUES_TAB_EDITAR_VIEW") !== false;

  const showTablero = hasFromBitset("ESTANQUES_TAB_TABLERO_VIEW");
  const showCrear = canCrearView && canCrearEdit;
  const showAdmin = canAdminView;

  const defaultTab = useMemo(() => {
    if (!canViewWindow) return null;
    if (initialTab === "tablero" && showTablero) return "tablero";
    if (initialTab === "crear" && showCrear) return "crear";
    if (initialTab === "administrar" && showAdmin) return "administrar";
    return showTablero ? "tablero" : showAdmin ? "administrar" : showCrear ? "crear" : null;
  }, [canViewWindow, initialTab, showCrear, showAdmin, showTablero]);

  const [tab, setTab] = useState(defaultTab);

  useEffect(() => {
    setTab(defaultTab);
  }, [defaultTab]);

  const selectTab = (next) => {
    setTab(next);
    onTabChange?.(next);
  };

  if (!canViewWindow) {
    return (
      <div className="bg-neutral-900 min-h-screen text-white p-2 sm:p-6 min-w-0 rounded-lg">
        <h2 className="text-green-400 text-3xl font-bold mb-4">Gestión de Estanques</h2>
        <div className="bg-neutral-800 border border-neutral-700 rounded p-4">
          <p className="text-sm text-neutral-300">No tienes permiso para ver esta sección.</p>
        </div>
      </div>
    );
  }

  if (!tab) {
    return (
      <div className="bg-neutral-900 min-h-screen text-white p-2 sm:p-6 min-w-0 rounded-lg">
        <h2 className="text-green-400 text-3xl font-bold mb-4">Gestión de Estanques</h2>
        <div className="bg-neutral-800 border border-neutral-700 rounded p-4">
          <p className="text-sm text-neutral-300">
            No hay pestañas disponibles con tus permisos actuales.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-neutral-900 min-h-screen text-white p-2 sm:p-6 min-w-0 rounded-lg">
      <h2 className="text-green-400 text-3xl font-bold mb-4">Gestión de Estanques</h2>

      {/* Botonera centrada */}
      <div className="mb-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          {showTablero && <button type="button" className={`min-h-12 rounded px-3 py-2 ${tab === "tablero" ? "bg-green-600" : "bg-gray-700"}`} onClick={() => selectTab("tablero")}>Tablero de estanques</button>}
          {showAdmin && (
            <button
              className={`min-h-12 px-4 py-2 rounded ${
                tab === "administrar" ? "bg-green-600" : "bg-gray-700 hover:bg-gray-600"
              }`}
              onClick={() => selectTab("administrar")}
            >
              Administrar Estanques
            </button>
          )}
          {showCrear && (
            <button
              className={`min-h-12 px-4 py-2 rounded ${
                tab === "crear" ? "bg-green-600" : "bg-gray-700 hover:bg-gray-600"
              }`}
              onClick={() => selectTab("crear")}
            >
              Crear Estanque
            </button>
          )}
        </div>
      </div>

      {/* Sin permisos para ningún tab */}
      {tab !== "tablero" && !showAdmin && !showCrear && (
        <div className="bg-neutral-800 border border-neutral-700 rounded p-4">
          <p className="text-sm text-neutral-300">
            No tienes permisos para ver pestañas de Estanques.
          </p>
        </div>
      )}

      {tab === "tablero" && showTablero && <TableroRecursos tipo="estanques" onOpen={selectTab} />}
      {tab === "administrar" && showAdmin && <AdministrarEstanques />}
      {tab === "crear" && showCrear && <CrearEstanque />}
    </div>
  );
};

export default Estanques;
